module.exports = __webpack_public_path__ + "_/_/src/components/toolbar/image/landlord3-icon-sleek-1.png";